var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"appear":"","name":"slide-fade","mode":"out-in"}},[_c('tile-grid')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }